import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../Helper/Helper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function MasonryShowcaseDesign() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setIsLoading(false);
    setFacilitiesData(response?.data);
  };



  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Our Facilities" Image="theme-2-banner-facilities.webp" />

        {/* <div
          id="portfolio-section"
          className="portfolio-section py-5 my-5 section-bg-img"
          style={{ backgroundImage: `url(/assets/images/mist/facilities-masonry-showcase-bg.jpg)` }}
        > */}
        <div className="px-3">
          <div className="row mt-5">
            <div className="offset-md-2 col-md-8">
              <div className="title-wrap text-center">
                <div className="section-title margin-bottom-60">
                  <h2 className="section-title mb-0 text-uppercase text-black" >
                    Provides Our {" "}
                    <span className="theme-color">Best Facilities</span>
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>
              </div>
            </div>
          </div>

          <div className="row portfolio-wrap portfolio-classic-pro">
            {isLoading ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <Spinner />
              </div>
            ) : facilitiesData?.length === 0 ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <h4>No Record Available</h4>
              </div>
            ) : (
              facilitiesData?.map((data, index) => (
                <div key={index} className="col-lg-4 mb-4 portfolio-item portfolio-overlay-wrap">
                  <div className="portfolio-thumb relative">
                    <Link
                      to={`/facility/${data?.facility_slug
                        ?.replaceAll(" ", "-")
                        ?.replaceAll("/", "-")}`}
                    >
                      <img
                        src={data?.facility_image ||
                          "/assets/images/default.jpg"}
                        className="img-fluid"
                        alt={data?.facility_title}
                        style={{ height: "auto", width: "100%", objectFit: "cover" }}
                      />
                    </Link>
                    <div className="portfolio-wrap mansory-services-mobile-view">
                      <div className="portfolio-details-overlay typo-white">
                        <h3 className="mb-2">
                          <Link
                            to={`/facility/${data?.facility_slug
                              ?.replaceAll(" ", "-")
                              ?.replaceAll("/", "-")}`}
                          >
                            {data?.facility_title}
                          </Link>
                        </h3>
                        <div className="portfolio-content w-75">
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                limitParagraphByCharLimit(data?.facility_short_description, 100) +
                                (data?.facility_short_description?.length > 100 ? "..." : ""),
                            }}
                          />
                        </div>
                      </div>
                      <div className="portfolio-icons">
                        <Link
                          to={`/facility/${data?.facility_slug
                            ?.replaceAll(" ", "-")
                            ?.replaceAll("/", "-")}`}
                          className="link-icon"
                        >
                          <i className="icon-link"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        {/* </div> */}
        <FooterWrapper />
      </div>
    </div>
  );
}

export default MasonryShowcaseDesign;
